module.exports = __webpack_public_path__ + "static/img/case_tab_11.ff7d38d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_11.png
// module id = QXvZ
// module chunks = 34